import { Component, ViewChild, ElementRef, Input, OnInit, OnDestroy, AfterViewInit, Inject, Output, EventEmitter } from '@angular/core';
import { FileRestrictions, SelectEvent, ClearEvent, RemoveEvent, FileInfo, FileState, UploadService, SuccessEvent } from '@progress/kendo-angular-upload';
import { HttpClient, HttpParamsOptions, HttpHeaders } from '@angular/common/http';
// import { SurveyCase, FileResult } from '../../model/isurveyEntities';

//infrastructure
import { environment } from '../../../environments/environment';
import { AgendasService } from 'src/app/Services/Agendas/agendas.service';
import { LoaderService } from 'src/app/Services/Loader/loader-service.service';
import { AuthService, InternalUserModel } from 'src/app/Services/AuthService/auth-service.service';
import { EmailService } from 'src/app/Services/Emails/email.service';
import { Notification_Service } from 'src/app/Services/Notifications/notification.service';
import { Agendas, AxiaFile, AxiaPetitionsRelationship } from 'src/app/model/agendas';
import { RegisteredAgentComponent } from '../registered-agent/registered-agent.component';
import { Subscription } from 'rxjs';
declare var $: any;

@Component({
  selector: 'upload-component',
  templateUrl: './upload-component.component.html',
  styleUrls: ['./upload-component.component.scss'],
})

export class UploadComponent implements OnInit, OnDestroy, AfterViewInit {

  @Input() public maxSize: number = 57671680;//104857600;// 52428800;// 
  @Input() public maxFilenameChar: number = 140;//104857600;// 52428800;// 
  @Input() public allowedExtension: string[] = ["PDF"];
  @Input() public folder: string =''; 
  @Input() public isDone: boolean;

  @Output() navigateToTabTwo = new EventEmitter<number>();
  @Output() navigateToTabFour = new EventEmitter<number>();

  public events: string[] = [];
  public selectedFiles: any = [];
  public successEventList: any[] =[];
  public uploadDefaultUrl: string = environment.uploadDefaultUrl;
  public uploadRemoveUrl: string = "removeUrl";
  public uploadRestrictions: FileRestrictions;
  public opened = false;
  public overpassedLimitDate =false;
  public overpassedLimitlist:string="";
  public navigateTo = '';
  public uploadedFileCount:number =0;
  public uploadedTransaction:any
  public transactionListToUpload:any=[]
  public uploadedTransactionList:any=[]
  public uploadedFileList:any=[]
  public errorList:string[];
  public successMessage: string = "";
  public successMessageTwo: string = "";
  public axiaEvidence: AxiaFile[] =[];
  public axiaPetitionsRelationship: AxiaPetitionsRelationship[]=[]
  public fileCount = 0;
  public petitionButttonToggleValue =true;
  public fileButttonToggleValue =true;
  
  currentURL='';
  //prefix:string =''
  header = new HttpHeaders({ 'Content-Type': 'application/json' });
  selectedAgendas:Agendas[];
  requestOptions = { headers: this.header };

  showSpinner=true;
  user: InternalUserModel={
    _agentId:"",
    _agentGuid:"",
    _username:"",
    _email:"",
    _emailTwo:"",
    _phone:"",
    _phone2:"",
    _agentName :"",
    _password :"",
    _confPassword :"",
    _AgentAddress1 :"",
    _AgentAddress2 :"",
    _AgentAddress3 :"",
    _AgentAddress4 :"",
    _AgentAddress5 :"",
    _fax:"",
    _business:"",
    _contact:"",
  }
  suSUB : Subscription;
  isAxiaDialogOpen: boolean=false;
  public  AxiaRequest:{
      listOfFileIDs: number[][] ;
      listOfFileName: string[] ;
      EventList: any[] ;          
  } = {       listOfFileIDs:[] , listOfFileName: [] , EventList: [] }
  uploadButtonClicked: boolean=false;



  constructor(private notificationService: Notification_Service, private _loaderService:LoaderService, private _emailService:EmailService,
    private _authService:AuthService, private http: HttpClient ,private _agendasService:AgendasService, private REC:RegisteredAgentComponent, private _elRef: ElementRef) {
    
    this.currentURL =  window.location.origin.includes('localhost')? "": environment.BaseURL;
    if(!(this._authService.getServiceEnvironment()=='Prod'))  this.maxFilenameChar = this.maxFilenameChar -20
    this.folder =  environment.uploadFolderName+ ((_authService.getServiceEnvironment()=='Prod')?'\\':'_Test\\') + _authService.getTaxYear() + "\\"; 
  }

  private _fileMutationObserver: MutationObserver;
  private _devDialogPreviewListener: EventListener;

  ngAfterViewInit(): void {
    this._fileMutationObserver = new MutationObserver(() => this._patchRemoveButtons());
    this._fileMutationObserver.observe(this._elRef.nativeElement, { childList: true, subtree: true });
  }

  private _patchRemoveButtons(): void {
    const buttons: NodeListOf<HTMLButtonElement> = this._elRef.nativeElement
      .querySelectorAll('kendo-upload-file-list-item-action-button button:not([data-ada-patched])');
    buttons.forEach((btn: HTMLButtonElement) => {
      btn.setAttribute('aria-label', 'Remove file');
      btn.setAttribute('title', 'Remove File');
      btn.setAttribute('data-ada-patched', '1');
    });
  }

  ngOnDestroy():void{
    if (this._fileMutationObserver) { this._fileMutationObserver.disconnect(); }
    if (this._devDialogPreviewListener) {
      window.removeEventListener('rp-dev-dialog-preview', this._devDialogPreviewListener);
    }
    if (this.suSUB) {
      this.suSUB.unsubscribe();
    }
  }

  ngOnInit() {
    this.errorList = [];
    this.uploadRestrictions = {
      allowedExtensions: this.allowedExtension,
      maxFileSize: this.maxSize
    };
    this.selectedAgendas =this._agendasService.dataStore.selectedAgendas
    this.suSUB = this._authService.selectedUser.subscribe(x=>{
      if(x){
        this.user =x;
        this.user._agentName = x._agentName;
      }
    });

    // [DEV — ADA Analysis] Register runtime listener (for "already on tab 3" path — event fired by nav-menu).
    this._devDialogPreviewListener = ((event: Event) => {
      const customEvent = event as CustomEvent<string>;
      this._applyDevDialogScenario(customEvent.detail);
    }) as EventListener;
    window.addEventListener('rp-dev-dialog-preview', this._devDialogPreviewListener);

    // [DEV — ADA Analysis] sessionStorage path (for "navigated from another route" or "was on a different tab" path).
    const devScenario = sessionStorage.getItem('rp-dev-scenario');
    if (devScenario) {
      sessionStorage.removeItem('rp-dev-scenario');
      this._applyDevDialogScenario(devScenario);
    }
  }

  // [DEV — ADA Analysis] Populates selectedFiles with dummy entries so dialogs that
  // depend on selectedFiles.length render correctly during ADA preview.
  private _seedDevSelectedFiles(total: number): void {
    this.selectedFiles = Array.from({ length: total }, (_, index) => ({
      uid: `dev-${index + 1}`,
      originalName: `evidence_document_${index + 1}.pdf`,
      name: `evidence_document_${index + 1}.pdf`
    }));
  }

  // [DEV — ADA Analysis] Sets real component state to simulate a specific UI scenario
  // so the target dialog or panel can be inspected for ADA/WCAG compliance.
  // Supported scenarios: pa-upload-completed, axia-processing, axia-expired,
  //   axia-eligible-none-selected, axia-eligible-selected,
  //   upload-error, continue-uploading, axia-deadline-alert.
  private _applyDevDialogScenario(scenario: string): void {
    if (!scenario) {
      return;
    }

    if (scenario === 'pa-upload-completed') {
      this._seedDevSelectedFiles(3);
      this.uploadedFileCount = 3;
      this.successMessage = `Number of file(s) successfuly <br> uploaded: ${this.uploadedFileCount} out of ${this.selectedFiles.length}.`;
      this.successMessageTwo = '';
      this.successEventList = [{}, {}, {}];
      this.AxiaRequest = {
        listOfFileIDs: [[101], [102], [103]],
        listOfFileName: ['evidence_document_1.pdf', 'evidence_document_2.pdf', 'evidence_document_3.pdf'],
        EventList: [{}, {}, {}]
      };
      this.isAxiaDialogOpen = false;
      this.overpassedLimitDate = false;
      return;
    }

    this.successMessage = '';
    this.successMessageTwo = '';
    this.isAxiaDialogOpen = true;
    this.overpassedLimitDate = false;
    this.overpassedLimitlist = '';
    this.AxiaRequest = { listOfFileIDs: [], listOfFileName: [], EventList: [] };

    if (scenario === 'axia-processing') {
      this._seedDevSelectedFiles(3);
      this.uploadedFileCount = 1;
      this.axiaPetitionsRelationship = [];
      this.axiaEvidence = [];
      return;
    }

    this._seedDevSelectedFiles(1);
    this.uploadedFileCount = 1;

    if (scenario === 'axia-expired') {
      this.axiaPetitionsRelationship = [
        { agenda: '2026-10001', canBeUploaded: false, checked: false, limitDate: '2026-05-20T09:00:00' } as any
      ];
      this.axiaEvidence = [
        { value: 'evidence_document_1.pdf', checked: false }
      ];
      this.overpassedLimitDate = true;
      return;
    }

    if (scenario === 'axia-eligible-none-selected') {
      this.axiaPetitionsRelationship = [
        { agenda: '2026-10001', canBeUploaded: true, checked: false, limitDate: '2026-05-20T09:00:00' } as any
      ];
      this.axiaEvidence = [
        { value: 'evidence_document_1.pdf', checked: false }
      ];
      return;
    }

    if (scenario === 'axia-eligible-selected') {
      this.axiaPetitionsRelationship = [
        { agenda: '2026-10001', canBeUploaded: true, checked: true, limitDate: '2026-05-20T09:00:00' } as any
      ];
      this.axiaEvidence = [
        { value: 'evidence_document_1.pdf', checked: true }
      ];
      return;
    }

    if (scenario === 'upload-error') {
      this.isAxiaDialogOpen = false;
      this.overpassedLimitDate = false;
      this.opened = false;
      this.successMessage = '';
      this.errorList = [
        'Invalid file type — only PDF, JPG, PNG are accepted.',
        'evidence_document_bad_name!@#.pdf',
        'File name too long (max 50 characters)',
        'evidence_document_with_a_very_long_filename_that_exceeds_the_allowed_limit.pdf'
      ];
      return;
    }

    if (scenario === 'continue-uploading') {
      this.isAxiaDialogOpen = false;
      this.overpassedLimitDate = false;
      this.errorList = [];
      this.successMessage = '';
      this.opened = true;
      return;
    }

    if (scenario === 'axia-deadline-alert') {
      this.isAxiaDialogOpen = false;
      this.errorList = [];
      this.successMessage = '';
      this.opened = false;
      this.overpassedLimitlist = '<strong>2026-10001</strong> — Transfer deadline has passed (May 20, 2026 9:00 AM EST)<br><strong>2026-10002</strong> — Transfer deadline has passed (May 20, 2026 9:00 AM EST)';
      this.overpassedLimitDate = true;
      return;
    }
  }
  
  public onUploadButtonClick(upload) { 
    this.uploadButtonClicked =false;
    this.selectedFiles.forEach(element => {
      this.axiaEvidence.push({value: element.originalName, checked:false});
    });
    this.uploadedFileCount =0;                                                      
    this._loaderService.InsertUploadTransaction(  Number(this._authService.dataStore.selectedUser._agentId), this.selectedAgendas.map(({agenda, hearingDate}) => ({agenda, hearingDate}))).subscribe((data:any) => {
      this.uploadedTransaction = data.tran;
      this.axiaPetitionsRelationship =data.agendastoAxia
      this.selectedAgendas.forEach(element => {
        element.limitAxiaUploadDateTime = data.agendastoAxia.filter(x => x.agenda === element.agenda)[0].limitDate ; 
      });
      this.axiaPetitionsRelationship.forEach(element => {
        element.checked =false;
      });
      this.transactionListToUpload.push(data)
      upload.uploadFiles();
    }, err=>{
      this.notificationService.errorNotif('Unable to upload. Error: '+err.error);
    });
  }

  axiaPetitionsRelationshipContainsTrueElements(){
    let result =this.axiaPetitionsRelationship.filter(x => x.canBeUploaded === true).length >0
    return result
  }

  getAxiaPetitionsRelationshipTrueElements(){
    let trueElements =this.axiaPetitionsRelationship.filter(x => x.canBeUploaded === true)
    // let result =trueElements.map((x:AxiaPetitionsRelationship) => x.agenda)
    return trueElements
  }
  
  
  getAxiaPetitionsTrueAndCheckedElements(){
    let trueElements =this.axiaPetitionsRelationship.filter(x => x.canBeUploaded === true && x.checked === true)
    let result =trueElements.map((x:AxiaPetitionsRelationship) => x.agenda)
    return result
  }

  getAxiaFilesCheckedElements(){
    let trueElements =this.axiaEvidence.filter(x => x.checked === true)
    let result =trueElements.map((x:AxiaFile) => x.value)
    return result
  }

  getAxiaPetitionsRelationshipFalseElements(){
    let trueElements =this.axiaPetitionsRelationship.filter(x => x.canBeUploaded === false)
    let result =trueElements.map((x:AxiaPetitionsRelationship) => x.agenda)
    return result
  }

  public getAxiaPetitionsRelationshipTrueElementsList(){
    let reducedList =  this.axiaPetitionsRelationship.filter(x => x.canBeUploaded === true)
    let list =   reducedList.map((x:AxiaPetitionsRelationship) => x.agenda).join(', ');
    return list;
  }

  public getAxiaPetitionsRelationshipFalseElementsList(){
    let reducedList = this.axiaPetitionsRelationship.filter(x => x.canBeUploaded === false)
    let list = reducedList.map((x:AxiaPetitionsRelationship) => x.agenda).join(', ');
    return list;
  }



  public onClearButtonClick(upload) {
    this.fileCount = 0;
    this.selectedFiles = [];
    upload.clearFiles();
  }

  public onSelectEvent(e) {
    this.fileCount += 1;
  }

  public onUploadEvent(e) {
    this.fileCount = 0;
  }

  public onRemoveEvent(e, upload) {
    if (this.fileCount > 0) {
      this.fileCount -= 1;
    }
  }

  public clearEventHandler(e: ClearEvent): void {
    this.log("Clearing the file upload");
    this.selectedFiles = [];
  }

  emitNavigation(value:number){// test This
    if(value === 2){
      this.navigateToTabTwo.emit()   //navigate to petition Selection
    }
    else if(value === 4){
      this.navigateToTabFour.emit(); //navigate to review
    }
  }

  close(LeaveTab) {
    if(LeaveTab==='yes' && this.navigateTo === 'anotherPetition'){
      this.emitNavigation(2);
    }
    if(LeaveTab==='yes' && this.navigateTo === 'reviewEvidence'){
      this.emitNavigation(4);
    }
    if(LeaveTab==='yes' && this.uploadedTransactionList.length >0){
      this.ManageSendingOfConfirmationEmail();
    }
    this.opened = false;
  }

  open( value:string) {
      this.navigateTo= value;
    this.opened = true;
    if(this.opened){
      setTimeout(x => {
        $("button.btn.btn-success.ng-star-inserted")[0]?.focus();
      }, 500);
    }
    this._agendasService.filterAgendas("Unheard Petitions", "",   "HearingDate",  null,'All')
    setTimeout(x => {
      $("button.btn.navBut.ng-star-inserted")[0].focus();
    }, 300);
  }
  onSelectedChange(item:any){
    this.axiaEvidence[this.axiaEvidence.indexOf(item)].checked = !item.checked
    if(this.getAxiaPetitionsTrueAndCheckedElements().length >0 && this.getAxiaFilesCheckedElements().length >0){
      setTimeout(x => {
        $("button.btn.btn-success.ng-star-inserted")[0]?.focus();
      }, 500);
    }
  }

  onSelectedAllPetitionsToggle(value:any){
    this.axiaPetitionsRelationship.forEach((item) => {
      if(item.canBeUploaded)item.checked = value;
    })
    this.petitionButttonToggleValue =!value
    setTimeout(x => {
      $("button.btn.btn-primary.ng-star-inserted")[1]?.focus();
    }, 500);
  }

  onSelectedAllFilesToggle(value:any){
    this.axiaEvidence.forEach((item) => {
      item.checked = value;
    })
    this.fileButttonToggleValue =!value
    setTimeout(x => {
      $("button.btn.btn-success.ng-star-inserted")[0]?.focus();
    }, 500);
  }

  onSelectedChangePetition(item:any){
    this.axiaPetitionsRelationship[this.axiaPetitionsRelationship.indexOf(item)].checked = !item.checked
    if(this.getAxiaPetitionsTrueAndCheckedElements().length >0 && this.getAxiaFilesCheckedElements().length >0){
      setTimeout(x => {
        $("button.btn.btn-success.ng-star-inserted")[0]?.focus();
      }, 500);
    }
  }

  public removeEventHandler(e: RemoveEvent): void {
    const uid = e.files[0]?.uid;
    const fileName = e.files[0]?.name || '';
    if (uid || fileName) {
      const allLis: HTMLElement[] = Array.from(
        this._elRef.nativeElement.querySelectorAll('.k-upload-files li, kendo-upload ul li')
      );
      const li = (
        allLis.find((el: HTMLElement) => el.getAttribute('data-uid') === uid) ||
        allLis.find((el: HTMLElement) => fileName && el.textContent?.includes(fileName))
      ) as HTMLElement;
      if (li) {
        const rect = li.getBoundingClientRect();
        const clone = li.cloneNode(true) as HTMLElement;
        const bg = getComputedStyle(li).backgroundColor;
        clone.style.cssText = [
          `position:fixed`,
          `top:${rect.top}px`,
          `left:${rect.left}px`,
          `width:${rect.width}px`,
          `height:${rect.height}px`,
          `margin:0`,
          `z-index:9999`,
          `pointer-events:none`,
          `background:${bg && bg !== 'rgba(0, 0, 0, 0)' ? bg : '#fff'}`,
          `border-bottom:1px solid rgba(0,0,0,0.08)`,
          `transform-origin:top`,
          `overflow:hidden`,
          `border-radius:4px`,
          `box-shadow:0 2px 8px rgba(0,0,0,0.06)`,
          `animation:fileSlideOut 0.65s cubic-bezier(0.55,0,0.7,1) forwards`
        ].join(';');
        document.body.appendChild(clone);
        setTimeout(() => { if (clone.parentNode) { clone.parentNode.removeChild(clone); } }, 700);
      }
    }
    if (this.fileCount > 0) {
      this.fileCount -= 1;
    }
    let index = this.selectedFiles.findIndex(item => item.uid === e.files[0].uid);
    if (index >= 0) {
      this.selectedFiles.splice(index, 1);
    }
  }

  public selectEventHandler(e: SelectEvent): void {
    //remove Duplicates
    this.uploadButtonClicked =true;
    setTimeout(x => {
      $("button.btn.btn-primary.ng-star-inserted")[1]?.focus();
    }, 500);
    this.errorList=[];
    var blockedFilesList =[];
    var selected = e.files;
    for (var i = 0; i < selected.length; i++) {
      var filename = selected[i].name;
      if (filename.length > this.maxFilenameChar) {
          e.preventDefault();
          blockedFilesList.push(filename);
          if(this.errorList.length === 0) this.errorList.push("File name too long (max " + this.maxFilenameChar + " characters)");
          this.errorList.push(filename);
          break;
      }

      for (var y = 0; y < this.selectedFiles.length; y++) {
          let name =this.selectedFiles[y].originalName;

          if (name === filename) {
              e.preventDefault();
              blockedFilesList.push(filename);
              if(this.errorList.length === 0) this.errorList.push("Duplicate file — already in the upload queue:");
              this.errorList.push(name);
              break;
          }
      };
      // Allowed: letters, numbers, spaces, one '.', '-', '_'
      const regex = /^[a-zA-Z0-9_\- ]+(\.[a-zA-Z0-9_\- ]+)?$/;
      if (!regex.test(filename)) {
          e.preventDefault();
          blockedFilesList.push(filename);
          if (this.errorList.length === 0) {
              this.errorList.push("Invalid filename — allowed characters: letters, numbers, space, '-', '_', and one '.'.");
          }
          this.errorList.push(filename);
          
          break;
      }
    }
 
    //Request Headers
    let headers = new HttpHeaders({
      'Content-Type': 'application/json'});
    let options = { headers: headers };       
    
    //Create Directory Request
    if(blockedFilesList.length==0){

      this.http.post<any>( this.currentURL + environment.CreateDirectory ,{ path: environment.UploadDirectoryPath + this.folder}, options).subscribe(result => {
      
        let that = this;
        e.files.forEach((file) => {
          this.fileCount += 1;
  
          //Validation error
          if (!file.validationErrors) {
            let reader = new FileReader();
            reader.onload = function (ev) {
              var stream = ev.currentTarget["result"].replace('data:' + file.rawFile.type + ';base64,', '');
              let uploadFile = {
                src: "",
                uid: file.uid,
                name: file.uid + '_' + file.name,
                originalName: file.name,
                mimeType: file.rawFile.type,
                stream: stream
              };
              if(!blockedFilesList.includes(file.name)) { 
                that.selectedFiles.unshift(uploadFile);
              }
            };
            reader.readAsDataURL(file.rawFile);
          }
          else {debugger
            this.errorList.push(file.name);
          }
        });
      }, 
      error => {debugger
        console.error(error.message)
        this.errorList.push("Upload failed — please try again.");
      });

    }
  //endOFFunction  
  }

  errorEventHandler(e: any) {
    console.log(e);
    e["files"].forEach(element => {
      this.errorList.push(element.name + ((e.response?.error?.ExceptionMessage) ? ' — ' + e.response.error.ExceptionMessage : ''));

        let index = this.selectedFiles.findIndex(item => item.uid === element.uid); 
        if (index >= 0) {
          this.selectedFiles.splice(index, 1);
        }
    });
  }

  private log(event: string): void {
    this.events.unshift(`${event}`);
  }

  public onUploadEventHandler(event: any) {
    if (this.fileCount > 0) { 
      this.fileCount -= 1; 
    }

    if(!this.folder) this.getfolderValue()
    if(!this.REC.prefix){
      if(this._agendasService.getSelectedAgendas() && this._agendasService.getSelectedAgendas()[0]){
        console.log('Agenda Selected, Prefix Set to: ' + this._agendasService.getSelectedAgendas()[0]?.petitionType + '_' + this._agendasService.getSelectedAgendas()[0]?.agenda)
        console.log('Agenda List: ' + this._agendasService.getSelectedAgendas()[0])
        this.REC.prefix= this._agendasService.getSelectedAgendas()[0]?.petitionType + '_' + this._agendasService.getSelectedAgendas()[0]?.agenda;
      }
    }
    event.data = {
      subfolder: "",
      fileNamePrefix: ""
    };

    event.data.fileNamePrefix = this.REC.prefix;
    event.data.subfolder = this.folder;
  }

  //First Upload Dialog
  dialogOneButtonSelection(value:string){
    //Open 2nd Dialog
    if(value =='OpenAxiaDialog'){
      this.isAxiaDialogOpen =true
      this.successMessage= "";
      this.successMessageTwo =""
      setTimeout(x => {
        $("button.btn.btn-primary.ng-star-inserted")[0]?.focus();
      }, 500);
    }
    else{//Abort opening Axia
      this.successMessage= "";
      this.successMessageTwo =""
      this.selectedFiles = [];
      this.emitNavigation(2);
    }
  }

  //Dialog Two Axia Transfer
  dialogTwoButtonSelection(value:string){
    if(value==='Transfer'){
      this.checkDateOverpassed();
      if(!this.overpassedLimitDate){
        this.SaveAxiaTransferAndEmailGroups()
        this.emitNavigation(2);
        this.selectedFiles = [];
      }
      else{
        this.isAxiaDialogOpen =false
        setTimeout(x => {
          $("button.btn.btn-primary.ng-star-inserted")[0]?.focus();
        }, 500);
      }
      
    }
    else{//Abort
      this.successEventList= [];
      this.AxiaRequest  = {       listOfFileIDs:[] , listOfFileName: [] , EventList: [] };
      this.uploadedTransactionList=[];
      this.uploadedFileList=[];
      this.isAxiaDialogOpen =false;
      this.emitNavigation(2);
    }
  }

  //dialog three when timing changed
  public closeConfirmation(status) { 
    if(status === 'continue'){
      this.isAxiaDialogOpen =true;
      this.overpassedLimitDate = false;
      this.overpassedLimitlist = "";
    }
    else {
      this.overpassedLimitDate = false;
      this.overpassedLimitlist = "";
      this.isAxiaDialogOpen = false;
    }
  }
  public successEventHandler(event: SuccessEvent) {
    const isUnique = !this.successEventList.some(existingEvent => existingEvent.files === event.files);
    if (isUnique) {
        this.successEventList.push(event);
    }
    this.uploadedFileCount += 1;
    
    if(this.axiaPetitionsRelationship.length === 1 && this.axiaEvidence.length === 1){
      this.onSelectedAllPetitionsToggle(this.petitionButttonToggleValue)
    }

    this.successMessage= "Number of file(s) successfuly <br> uploaded: " + this.uploadedFileCount + " out of " + this.selectedFiles.length + "." ;
    this.successMessageTwo =(this.selectedAgendas.length> 1)?'Process might be slower when many petitions are selected.':''
    if(this.uploadedFileCount === this.selectedFiles.length){
      //make DB changes.
      this.SaveUploadRelationshipAndEmailGroups();
      setTimeout(x => {
        $("button.btn.btn-success.ng-star-inserted")[0]?.focus();
      }, 500);
    }

    this.uploadedTransactionList.push(  this.uploadedTransaction.uploadTransactionId ) ;
  }

  public SaveUploadRelationshipAndEmailGroups(){
    //handle events and save Upload PA Evidence
    // let ListOfPaths = this.successEventList.map(x  => this.folder + x.response.body.ServerFileName);
    let counter = this.successEventList.length;
    //this._loaderService.multiplyFiles({FilesPath: ListOfPaths, Agendas:this.selectedAgendas.map(x  => x.agenda)}).subscribe(data => {
        this.successEventList.forEach(event =>{
          if(event.files){
            this.uploadedFileList.push( event.response.body.OriginalFileName )
            this._loaderService.InsertUploadFile(
              { 
                UploadTransactionId: this.uploadedTransaction.uploadTransactionId,
                Agendas: this.selectedAgendas.map(x  => x.agenda),
                OriginalFileName : event.response.body.OriginalFileName,
                ServerFileName   : event.response.body.ServerFileName,
                Size : event.files[0].size,
                LastModifiedDate: event.files[0].rawFile.lastModifiedDate,
                Type: event.files[0].rawFile.type,
                Extention: event.files[0].extension,
                Path: this.folder + event.response.body.ServerFileName,
                Uploaded:true,
                UploadDescription:'',
                IsProcessed:true,
                SendToAxia: this.axiaEvidence.filter(x => x.value === event.response.body.OriginalFileName && x.checked == true).length > 0,
                SendToAxiaForAgendas:  this.getAxiaPetitionsTrueAndCheckedElements(),
                IsFirstRequest: this.successEventList[0]== event,
                FileIdList: [],
                eventIndex: this.successEventList.indexOf(event),
                masterAgenda: this._agendasService.dataStore.masterAgenda,
                totalRecords: this.successEventList.length * this.selectedAgendas.length
              }
            ).subscribe((data:any) => {
              counter--;
              this.AxiaRequest.listOfFileIDs.push(data.listOfFileIDs)
              this.AxiaRequest.listOfFileName.push(data.fileName)
              this.AxiaRequest.EventList.push(this.successEventList[data.eventIndex])
              if(counter === 0){
                this._loaderService.GetAllUploadsData(this._authService.dataStore.selectedUser._agentId).subscribe({
                  error: () => {
                    this.notificationService.errorNotif("Unable to refresh submission history. Please try again.");
                  }
                })
                this.ManageSendingOfConfirmationEmail();
              }

            }, err=>{
              this.notificationService.errorNotif("Error at the Contacting DB. If the error persists please contact our office at (305) 375-4109.");
              this.successMessage="";
            });
          }
        });
    //   }, err=>{   
    //     this.notificationService.errorNotif("Error at the time of segregating files.(Files not uploaded correctly) If the error persists please contact our office at (305) 375-4109.");
    //     $( "ul.k-upload-files.k-reset" ).addClass( "DisplayNone" );
    //     $( "div.k-button.k-upload-button" ).addClass( "DisplayNone" );
    //     this.uploadedTransactionList=[];
    // });
  }

  public SaveAxiaTransferAndEmailGroups(){
    //Handle events and save Transfer Axia Files
    let counter = this.AxiaRequest.EventList.length;
    this.AxiaRequest.EventList.forEach(event =>{
      let index = this.AxiaRequest.EventList.indexOf(event)
      if(event.files){
        this.uploadedFileList.push( event.response.body.OriginalFileName )
        this._loaderService.ExecuteAxiaTransfer(
          { 
            Agendas: this.selectedAgendas.map(x  => x.agenda),
            OriginalFileName : this.AxiaRequest.listOfFileName[index],
            Path: this.folder + event.response.body.ServerFileName,
            SendToAxia: this.axiaEvidence.filter(x => x.value === event.response.body.OriginalFileName && x.checked == true).length > 0,
            SendToAxiaForAgendas:  this.getAxiaPetitionsTrueAndCheckedElements(),
            FileIdList: this.AxiaRequest.listOfFileIDs[index]
          }
        ).subscribe(data => {
          counter--;
          if(counter === 0){
            this.AxiaRequest  = { listOfFileIDs:[] , listOfFileName: [] , EventList: [] }
            this._loaderService.GetAllUploadsData(this._authService.dataStore.selectedUser._agentId).subscribe({
              error: () => {
                this.notificationService.errorNotif("Unable to refresh submission history. Please try again.");
              }
            })
            this.ManageSendingOfAxiaTransferConfirmationEmail()
          }
        }, err=>{
          this.notificationService.errorNotif("Error at the Contacting DB. If the error persists please contact our office at (305) 375-4109.");
        });
      }
    });

    this.successEventList= [];
  }

  ManageSendingOfConfirmationEmail() {
    this._emailService.SendUploadTransactionEmail(this.selectedAgendas, this.uploadedTransactionList, this.uploadedFileList, [], this.getAxiaPetitionsTrueAndCheckedElements())
      .subscribe(data => {
        this.notificationService.successNotif("'Successful Upload' A receipt email was successfuly sent to the Agent. Email address: "+ this.user._emailTwo + ".", true);
      }, err=>{
        this.notificationService.errorNotif((err.error)?err.error : "Unknown Error :" + err.message + ". Please refresh browser and attempt again. If the error persists please contact our office at (305) 375-4109.");
    });
  }

  ManageSendingOfAxiaTransferConfirmationEmail() {
    this._emailService.SendAxiaTransactionEmail(this.selectedAgendas, this.uploadedTransactionList, this.uploadedFileList, this.getAxiaFilesCheckedElements(), this.getAxiaPetitionsTrueAndCheckedElements())
      .subscribe(data => {
        this.notificationService.successNotif("'Successful Axia Transfer' A receipt email was successfuly sent to the Agent. Email address: "+ this.user._emailTwo + ".", true);
        this.axiaEvidence=[]; 
      }, err=>{
        this.notificationService.errorNotif((err.error)?err.error : "Unknown Error :" + err.message + ". Please refresh browser and attempt again. If the error persists please contact our office at (305) 375-4109.");
    });
    this.uploadedTransactionList=[];
    this.uploadedFileList=[];
  }

  getfolderValue(): void {
    if(!this._authService.getTaxYear() || !this._authService.getServiceEnvironment()){
      this.notificationService.errorNotif('Error at isAppOffline not bringing config variables. refresh your browser and notify us of the issue.');
    }
    else{
      this.folder = environment.uploadFolderName + ((this._authService.getServiceEnvironment() ==='Prod')?'//':'_Test//') + this._authService.getTaxYear() + "//"; 
    }
  }
  

  public checkDateOverpassed() {
    var todaysDate = new Date();//Hardcoded to always see = new Date('2024-03-31');
    let goodToUploadpetitions = this.axiaPetitionsRelationship.filter(x => x.canBeUploaded === true && x.checked ==true)
    goodToUploadpetitions.forEach(element => {
      if(this.selectedAgendas.filter(x => x.agenda === element.agenda)[0].limitAxiaUploadDateTime){
        let limitDate = new Date(this.selectedAgendas.filter(x => x.agenda === element.agenda)[0].limitAxiaUploadDateTime);
        if( limitDate <= todaysDate){
          this.overpassedLimitDate= true;
          this.overpassedLimitlist += element.agenda+', '
          this.axiaPetitionsRelationship.filter(x => x.agenda === element.agenda).forEach(element => {
            element.canBeUploaded= false ;
            element.checked= false ;
          });
        }
      }

    });
  }

}
